import { OktaAuth } from "@okta/okta-auth-js";
import { AUTH_ROUTES } from "../utils/RoutesConstant";

export const OktaConstructor = () => {
    const redirectUri = `${window.location.origin}/${AUTH_ROUTES.LoginCallback}`;
    const logoutRedirectUri = `${window.location.origin}`;
    const clientId = process.env.REACT_APP_OKTA_CLIENT_ID;
    const nodeEnv = process.env.REACT_APP_NODE_ENV;

    const oktaConfig = {
        oktaAuth: {
            clientId,
            issuer: `https://${process.env.REACT_APP_OKTA_DOMAIN}/oauth2/default`,
            redirectUri,
            scopes: ["openid", "profile", "email", "offline_access"],
            pkce: true,
            responseType: ["token", "id_token", "refresh_token"],
            tokenManager: {
                autoRenew: true,
                storage: "localStorage",
                expireEarlySeconds: 600,
                secure: nodeEnv !== "local" ? true : false,
                storageKey: "okta-token-storage",
            },
        },
        domain: process.env.REACT_APP_OKTA_DOMAIN,
    };

    const oktaClient = new OktaAuth(oktaConfig.oktaAuth);

    return { oktaClient, oktaConfig, logoutRedirectUri };
};
